import React from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function TopDoctors({ doctors = [], isLoading, isSuccess }) {
  const navigate = useNavigate();

  return (
    <div
      className="card"
      style={{ maxHeight: "500px", display: "flex", flexDirection: "column" }}
    >
      {/* Header */}
      <div style={{ flex: "0 0 auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p style={{ color: "#f97316" }}>Top Rated Doctors</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              color: "#2BC155",
              cursor: "pointer",
            }}
            onClick={() => navigate("/Doctors")}
          >
            View <MdKeyboardDoubleArrowRight />
          </div>
        </div>
      </div>

      {/* List */}
      <div
        style={{ flex: "1 1 auto", overflowY: "auto", marginTop: "10px" }}
        className="hide-scrollbar"
      >
        {isLoading && <p>Loading...</p>}

        {isSuccess && doctors.length > 0
          ? doctors.map((doc, idx) => (
              <div key={idx} className="list-item">
                <div>
                  <div>{doc.doctorName}</div>
                  <small>{doc.specialization}</small>
                  <br />
                  <small>
                    Joined:{" "}
                    {new Date(doc.joinDate)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .replace(/ /g, "-")}
                  </small>
                </div>
                <div
                  className="badge py-3"
                  style={{ fontSize: "14px", fontWeight: 500 }}
                >
                  {doc.totalAppointments}
                </div>
              </div>
            ))
          : !isLoading && <p>No top doctors found</p>}
      </div>
    </div>
  );
}

export default TopDoctors;
